





import { Component, Prop, Vue } from 'vue-property-decorator';
import ChangeComponent from "@/views/password/Change.vue";
import ResultComponent from "@/views/password/Result.vue";

//import RedirectLocations from "@/location/redirectlocations";
import {mapGetters} from "vuex";

@Component({
    components: {
        ChangeComponent,
        ResultComponent,
    },
    computed:
        mapGetters({
            progress:'changePassword/progress'
        }),
})
export default class SignIn extends Vue {
    @Prop() private msg!: string;

    toReturn() {
        location.href = String(this.$route.query.referer);
    }
}
